import { styled } from "@mui/material/styles";
import {
  DataGridPro,
  DataGridProProps,
  GridColDef,
  GridPagination,
  GridSlotsComponentsProps,
} from "@mui/x-data-grid-pro";
import { LicenseInfo } from "@mui/x-license-pro";
import React from "react";

import { getConfig } from "config/config";

const config = getConfig();

if (config.REACT_APP_MUI_LICENSE_KEY) {
  LicenseInfo.setLicenseKey(config.REACT_APP_MUI_LICENSE_KEY);
}

export interface StyledDataGridProps extends Omit<DataGridProProps, "rows" | "columns"> {
  rows?: any;
  columns: GridColDef[];
}

const StyledGrid = styled(DataGridPro)(() => ({
  backgroundColor: "#FFFFFF",
  border: "none",
  // style for header row
  ".MuiDataGrid-columnHeaderTitle": {
    fontSize: "20px",
    fontWeight: "600",
  },
  // style to remove header separators
  ".MuiDataGrid-columnSeparator": {
    display: "none",
  },
  // style to remove margin right for pinned columns
  "& .MuiDataGrid-pinnedColumnHeaders, .MuiDataGrid-pinnedColumns": {
    marginRight: "0.5rem",
  },
  // style for content rows
  ".MuiDataGrid-row": {
    cursor: "pointer",
    fontSize: "14px",
    lineHeight: "20px",
    backgroundColor: "#F2F5F6",
  },
  "& .MuiDataGrid-row:nth-child(2n)": {
    backgroundColor: "#FFFFFF",
  },
  // style for content cells
  ".MuiDataGrid-cell": {
    border: "none",
  },
  // style to for ellipsis on overflow
  // "& .MuiDataGrid-columnHeaderTitle": {
  //   whiteSpace: "normal",
  //   lineHeight: "1.5em",
  //   overflow: "hidden",
  //   textOverflow: "ellipsis",
  // },
  // // styles for pagination
  // ".MuiDataGrid-footerContainer": {
  //   border: "none",
  //   fontSize: "16px",
  // },
  // ".MuiTablePagination-selectLabel": {
  //   fontSize: "16px",
  // },
  // ".MuiTablePagination-displayedRows": {
  //   fontSize: "16px",
  // },
  "& .MuiTablePagination-root": {
    marginRight: "50px",
  },
}));

export function StyledDataGrid(props: StyledDataGridProps) {
  const { loading, rows, columns, ...restProps } = props;

  return (
    <StyledGrid
      rows={rows}
      columns={columns}
      rowHeight={70}
      headerHeight={80}
      loading={loading}
      {...restProps}
      components={{
        ...restProps.components,
        Pagination: CustomPagination,
      }}
      componentsProps={{
        pagination: { loading },
      }}
    />
  );
}

function CustomPagination(props: GridSlotsComponentsProps["pagination"]) {
  // This custom pagination contains the logic to disable the next or back button when it's loading the data
  const { loading, ...paginationProps } = props;
  const buttonProps = loading ? { disabled: loading } : undefined;
  return <GridPagination {...paginationProps} nextIconButtonProps={buttonProps} backIconButtonProps={buttonProps} />;
}
